<template>
  <div class="personal-center-page">
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">个人中心</h1>
        </div>
      </div>
    </div>

    <!-- 金色banner卡片 -->
    <div
      class="golden-banner"
      :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
    >
      <img
        src="@/assets/college/vip-card/card.png"
        alt="卡片背景"
        class="card-background"
      />
      <!-- 原 Logo 模板保留，恢复方式见 college/config.js 的 showShandongUniversityLogo 开关。 -->
      <img
        v-if="collegeName[productId].showLogo !== false"
        :src="collegeName[productId].logoCard"
        alt="logo"
        class="logo-image"
      />
      <img
        src="@/assets/college/vip-card/vip.png"
        alt="vip"
        class="vip-image"
      />
      <img
        src="@/assets/college/vip-card/super.png"
        alt="super"
        class="super-image"
      />
      <img
        src="@/assets/college/vip-card/text.png"
        alt="text"
        class="text-image"
      />
      <div class="vip-card-text">
        <span>{{ orgName }}</span>
        <div
          v-if="hasMultipleOrgs"
          class="switch-org-btn"
          @click="showOrgSelectDialog = true"
        >
          <van-icon name="exchange" size="14" />
        </div>
      </div>
    </div>

    <!-- 我的操作区域 -->
    <div class="operations-section">
      <h3 class="section-title">我的操作</h3>
      <div class="operation-icons">
        <div class="operation-item" @click="goToCustomerList(1)">
          <div class="icon-circle">
            <van-icon name="friends" size="32" color="#8b4513" />
          </div>
          <span class="icon-label">存储客户列表</span>
        </div>

        <div class="operation-item" @click="goToCustomerList(2)">
          <div class="icon-circle">
            <van-icon name="friends-o" size="32" color="#8b4513" />
          </div>
          <span class="icon-label">检测客户列表</span>
        </div>

        <div class="operation-item" @click="goToMail">
          <div class="icon-circle">
            <van-icon name="envelop-o" size="32" color="#8b4513" />
          </div>
          <span class="icon-label">去邮寄</span>
        </div>

        <div class="operation-item" @click="goToStatisticsList()">
          <div class="icon-circle">
            <van-icon name="friends" size="32" color="#8b4513" />
          </div>
          <span class="icon-label">数据统计列表</span>
        </div>
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <div class="logout-section">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>

    <!-- 组织选择弹窗 -->
    <van-popup
      v-model="showOrgSelectDialog"
      position="center"
      :close-on-click-overlay="false"
      :style="{ width: '90%', maxWidth: '400px', borderRadius: '16px' }"
    >
      <div class="org-select-dialog">
        <div class="dialog-header">
          <div class="dialog-icon">
            <van-icon name="shop-o" size="24" color="#bb7849" />
          </div>
          <h3 class="dialog-title">选择机构</h3>
          <p class="dialog-subtitle">请选择您要使用的机构</p>
        </div>
        <div class="org-list">
          <div
            v-for="(org, index) in organizationList"
            :key="index"
            class="org-item"
            :class="{ selected: selectedOrgId === org.orgId }"
            @click="selectOrganization(org)"
          >
            <div class="org-item-content">
              <div class="org-item-left">
                <div class="org-icon-wrapper">
                  <van-icon name="shop-o" size="20" />
                </div>
                <div class="org-info">
                  <div class="org-name">{{ org.orgName }}</div>
                </div>
              </div>
              <div class="org-item-right">
                <div v-if="selectedOrgId === org.orgId" class="check-circle">
                  <van-icon name="success" size="14" color="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { college } from "../college/config";

export default {
  name: "MedicalUniversityPersonalCenter",
  data() {
    return {
      orgName: "",
      showOrgSelectDialog: false,
      organizationList: [],
      selectedOrgId: null, // 当前选中的组织ID
      hasMultipleOrgs: false, // 是否有多个组织
      collegeName: college,
      productId: '0'
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = urlParams.get("productId") || localStorage.getItem("productId") || "0";
  },
  mounted() {
    this.orgName = localStorage.getItem("medical_university_user");
    // 检查是否需要显示组织选择弹窗
    this.checkAndShowOrgSelect();
  },
  methods: {
    checkAndShowOrgSelect() {
      const haveManyOrg =
        localStorage.getItem("medical_university_haveManyOrg") == "true";
      this.hasMultipleOrgs = haveManyOrg;
      if (haveManyOrg) {
        const organizationListStr = localStorage.getItem(
          "medical_university_organizationList"
        );
        if (organizationListStr) {
          try {
            this.organizationList = JSON.parse(organizationListStr);
            // 检查是否已经选择过组织
            const selectedOrgIdStr = localStorage.getItem(
              "medical_university_selectedOrgId"
            );
            if (selectedOrgIdStr) {
              // 如果已经选择过，设置选中状态
              this.selectedOrgId = parseInt(selectedOrgIdStr, 10);
            }
            if (!selectedOrgIdStr) {
              // 如果还没有选择过，显示选择弹窗
              this.showOrgSelectDialog = true;
            }
          } catch (error) {
            console.error("解析组织列表失败:", error);
          }
        }
      }
    },
    // 切换机构
    switchOrganization() {
      if (this.hasMultipleOrgs && this.organizationList.length > 0) {
        this.showOrgSelectDialog = true;
      }
    },
    selectOrganization(org) {
      // 更新选中状态
      if (org.id) {
        this.selectedOrgId = org.id;
        localStorage.setItem(
          "medical_university_selectedOrgId",
          org.id.toString()
        );
      }
      // 更新显示的机构名
      if (org.orgName) {
        this.orgName = org.orgName;
        localStorage.setItem("medical_university_user", org.orgName);
      }
      // 延迟关闭弹窗，让用户看到选中效果
      setTimeout(() => {
        this.showOrgSelectDialog = false;
        this.$toast("已切换到机构：" + org.orgName);
      }, 300);
    },
    goToStatisticsList() {
      let url = `/medical-university/statistics`;
      if (this.productId !== '0') url += `?productId=${this.productId}`
      if (process.env.NODE_ENV === "production") {
        window.location.href = `https://yisheng.healthmore.net${url}`;
      } else {
        this.$router.push(url);
      }
    },
    goToCustomerList(type) {
      // type: 1=存储, 2=检测
      let url = `/medical-university/customers?type=${type}`;
      if (this.productId !== '0') url += `&productId=${this.productId}`
      if (process.env.NODE_ENV === "production") {
        window.location.href = `https://yisheng.healthmore.net${url}`;
      } else {
        this.$router.push(url);
      }
    },
    goToMail() {
      // 获取选中的机构ID
      const selectedOrgId = localStorage.getItem("medical_university_selectedOrgId");
      let url = selectedOrgId 
        ? `/medical-university/mailing?orgId=${selectedOrgId}`
        : "/medical-university/mailing";
      if (this.productId !== '0') {
        url += selectedOrgId ? `&productId=${this.productId}` : `?productId=${this.productId}`
      }
      
      
      if (process.env.NODE_ENV === "production") {
        window.location.href = `https://yisheng.healthmore.net${url}`;
      } else {
        this.$router.push(url);
      }
    },
    handleLogout() {
      this.$dialog
        .confirm({
          title: "确认退出",
          message: "确定要退出登录吗？",
        })
        .then(() => {
          // 清除本地存储
          localStorage.removeItem("medical_university_token");
          localStorage.removeItem("medical_university_user");
          localStorage.removeItem("medical_university_organizationList");
          localStorage.removeItem("medical_university_haveManyOrg");
          localStorage.removeItem("medical_university_selectedOrgId");

          this.$toast("已退出登录");

          // 跳转到登录页
          this.$router.push({
            path: "/client/login",
            query: {
              productId: this.productId,
            },
          });
        })
        .catch(() => {
          // 用户取消
        });
    },
  },
};
</script>

<style scoped src="../college/logo-layout.css"></style>

<style scoped>
.personal-center-page {
  min-height: 100vh;
  background: #fff;
  position: relative;
  padding-bottom: 90px; /* 为固定的退出按钮留出空间 */
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 页面标题 */
.page-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
}

.page-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 金色banner卡片 */
.golden-banner {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -160px;
}

.card-background {
  width: 100%;
  height: auto;
  display: block;
}
.logo-image {
  position: absolute;
  width: 200px;
  left: 40px;
  top: 20px;
}
.text-image {
  position: absolute;
  width: 280px;
  left: 40px;
  top: 80px;
}
.super-image {
  position: absolute;
  width: 50px;
  left: 40px;
  top: 115px;
}
.vip-image {
  position: absolute;
  width: 30px;
  left: 95px;
  top: 111px;
}
.vip-card-text {
  position: absolute;
  right: 40px;
  top: 145px;
  padding: 7px 10px;
  border-radius: 3px;
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
  color: rgb(126, 86, 33);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch-org-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(126, 86, 33, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  flex-shrink: 0;
}

.switch-org-btn:active {
  background: rgba(126, 86, 33, 0.25);
  transform: scale(0.95);
}

.switch-org-btn .van-icon {
  color: rgb(126, 86, 33);
}

/* 我的操作区域 */
.operations-section {
  padding: 0 20px 30px 20px;
  background: white;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
}

.operation-icons {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  flex-wrap: wrap;
}

.operation-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s;
}

.operation-item:hover {
  transform: translateY(-5px);
}

.icon-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
}

.icon-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 退出登录按钮 */
.logout-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  /* background: white; */
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
  z-index: 100;
}

.logout-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border: none;
  border-radius: 25px;
  color: #8b4513;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
}

.logout-btn:hover {
  background: linear-gradient(135deg, #c19b2e 0%, #e6c035 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .header-banner {
    height: 200px;
  }

  .golden-banner {
    padding: 0 15px 15px;
  }

  .icon-circle {
    width: 70px;
    height: 70px;
  }

  .operation-icons {
    gap: 10px;
  }
}

/* 组织选择弹窗样式 */
.org-select-dialog {
  padding: 0;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}

.org-select-dialog .dialog-header {
  padding: 24px 20px 20px;
  text-align: center;
  background: linear-gradient(
    135deg,
    rgba(245, 196, 133, 0.1) 0%,
    rgba(254, 221, 189, 0.1) 100%
  );
  border-bottom: 1px solid #f0f0f0;
}

.org-select-dialog .dialog-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  background: linear-gradient(
    135deg,
    rgba(245, 196, 133, 0.2) 0%,
    rgba(254, 221, 189, 0.2) 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.org-select-dialog .dialog-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 6px 0;
}

.org-select-dialog .dialog-subtitle {
  font-size: 13px;
  color: #999;
  margin: 0;
}

.org-select-dialog .org-list {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  padding: 16px;
  background: #fafafa;
}

.org-select-dialog .org-item {
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.org-select-dialog .org-item:last-child {
  margin-bottom: 0;
}

.org-select-dialog .org-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

.org-select-dialog .org-item:hover .org-item-content {
  box-shadow: 0 4px 12px rgba(187, 120, 73, 0.15);
  transform: translateY(-2px);
}

.org-select-dialog .org-item:active .org-item-content {
  transform: translateY(0);
}

.org-select-dialog .org-item.selected .org-item-content {
  background: linear-gradient(
    135deg,
    rgba(245, 196, 133, 0.15) 0%,
    rgba(254, 221, 189, 0.15) 100%
  );
  border-color: #bb7849;
  box-shadow: 0 4px 16px rgba(187, 120, 73, 0.2);
}

.org-select-dialog .org-item-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.org-select-dialog .org-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(
    135deg,
    rgba(245, 196, 133, 0.2) 0%,
    rgba(254, 221, 189, 0.2) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  transition: all 0.3s;
}

.org-select-dialog .org-item.selected .org-icon-wrapper {
  background: linear-gradient(
    135deg,
    rgba(245, 196, 133, 0.3) 0%,
    rgba(254, 221, 189, 0.3) 100%
  );
}

.org-select-dialog .org-icon-wrapper .van-icon {
  color: #bb7849;
}

.org-select-dialog .org-info {
  flex: 1;
  min-width: 0;
}

.org-select-dialog .org-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.5;
  transition: all 0.3s;
  word-break: break-all;
}

.org-select-dialog .org-item.selected .org-name {
  color: #bb7849;
  font-weight: 600;
}

.org-select-dialog .org-item-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 12px;
}

.org-select-dialog .check-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #bb7849 0%, #d4af37 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(187, 120, 73, 0.3);
  animation: scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
